






























import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";
import Connectors from "./partials/charging-stations/Connectors.vue";
import appService from "@/services/appService";
import centrifugeClientFactory from "@/services/centrifugeClientFactory";
import merge from "@common/modules/vuetifyx/utils/merge";
import BlurredTenant from "@/components/BlurredTenant.vue";


export default Vue.extend({
    components: { Connectors, BlurredTenant },
    data() {
        const _this = this;
        return {
            showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
            self: this,
            tableContainer: new DataContainer(),
            tableOptions: {
                attrs: {
                    "item-key": "_id",
                    "sort-by": "name",
                    "sort-desc": false,
                    "show-expand": true,
                },
                content: {
                    name: "Smart Sockets",
                    urlEnabled: true,
                    search: {
                        ext: {
                            hidden: true,
                        },
                    },
                    filters: {
                        filters: {
                            tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Organization",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call(
                                                    "tenants",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            chargingLocationId: {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Site",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const tenant = userManager.getUserInfo().tenant;
                                                const filters = [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ];
                                                if (tenant) {
                                                    filters.push({
                                                        key: "tenantId",
                                                        operator: "equal_to",
                                                        value: tenant._id,
                                                    });
                                                }
                                                const { items } = await coreApiClient.call(
                                                    "chargingLocations",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters,
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            retailerId: userManager.checkRole([
                                "systemAdmin",
                                "admin",
                                "cpoAdmin", "cpoMonitor",
                            ]) && {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Retailer",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call(
                                                    "retailers",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            serialNumber: {
                                attrs: {
                                    label: "Serial Number",
                                },
                                rules: {
                                    match: {},
                                },
                            },
                            uniqueId: {
                                attrs: {
                                    label: "Smart Socket ID",
                                },
                                rules: {
                                    match: {},
                                },
                            },
                            "connectorSettingItems.qrCode": {
                                attrs: {
                                    label: "QR Code",
                                },
                                rules: {
                                    match: {},
                                },
                            }
                        },
                    },
                    displayFields: {
                        chargerPointName: {
                            text: "Smart Socket Name",
                            sortable: true,
                            options: {
                                attrs: {
                                    class: "font-weight-bold",
                                },
                            },
                        },
                        uniqueId: {
                            text: "Smart Socket ID",
                            sortable: true,
                            options: {
                                attrs: {
                                    class: "font-weight-bold",
                                },
                            },
                        },
                        connectors: {
                            text: "Receptacles",
                        },
                        chargingLocation: {
                            text: "Site",
                            options: {
                                subProp: "chargingLocation.name",
                                label: true,
                                sortBy: "chargingLocationId",
                            },
                        },
                        retailer: {
                            text: "Retailer",
                            options: {
                                subProp: "retailer.name",
                                label: true,
                                sortBy: "retailerId",
                            },
                        },
                        isPrivate: {
                            text: "Mode",
                            options: {
                                boolean: true,
                                label: (value: boolean) => {
                                    return value ? "Private" : "Public";
                                },
                                attrs(value) {
                                    return {
                                        color: value ? "red" : "green",
                                    };
                                },
                            },
                        },
                        power: {
                            text: "Power (KW)",
                            sortable: true,
                        },
                        chargingLocationAddress: {
                            text: "Address",
                            options: {
                                subProp: "chargingLocation.address",
                                tooltip: {
                                    content: {
                                        text: "chargingLocation.address",
                                    },
                                },
                                attrs: {
                                    class: "address-station two-line-text",
                                    // style: "width: 150px !important;  " +
                                    //     "display: -webkit-box;\n" +
                                    //     "  -webkit-line-clamp: 2;\n" +
                                    //     "  -webkit-box-orient: vertical;\n" +
                                    //     "  overflow: hidden;\n" +
                                    //     "  text-overflow: ellipsis;\n" +
                                    //     "  word-wrap: break-word;"
                                },
                            },
                        },
                        createdTime: {
                            text: "Created Time",
                            sortable: true,
                            options: {
                                filter: "dateTime",
                            },
                        },
                        updatedTime: {
                            text: "Updated Time",
                            sortable: true,
                            options: {
                                filter: "dateTime",
                            },
                        },
                        tenant: userManager.checkRole(["systemAdmin", "admin"]) && {
                            text: "Organization",
                            options: {
                                subProp: "tenant.name",
                                label: true,
                                sortBy: "tenantId",
                            },
                        },
                        action: {
                            text: "Actions",
                        },
                    },
                    multiSelectActionButtons: {
                        export: userManager.checkRole([
                            "systemAdmin",
                            "admin",
                            "cpoAdmin", "cpoMonitor",
                            "retailer",
                        ]) && {
                            content: {
                                text: "Export selected",
                                icon: "mdi-microsoft-excel",
                            },
                            on: {
                                xClick({ self }) {
                                    const dataTable = self.context();
                                    coreApiClient.download("chargingStations", `@/export`, {
                                        payload: JSON.stringify({
                                            filters: [
                                                {
                                                    key: "_id",
                                                    operator: "in",
                                                    value: dataTable.model.value.map((item) => item._id),
                                                },
                                            ],
                                            limit: -1,
                                            extraParams: {
                                                currentTimeZoneOffset:
                                                    new Date().getTimezoneOffset() * -1 * 60 * 1000,
                                            },
                                        }),
                                    });
                                },
                            },
                        },
                    },
                    topActionButtons: {
                        export: userManager.checkRole([
                            "systemAdmin",
                            "admin",
                            "cpoAdmin", "cpoMonitor",
                            "retailer",
                        ]) && {
                            content: {
                                text: "Export all",
                                icon: "mdi-microsoft-excel",
                            },
                            on: {
                                xClick({ self }) {
                                    const dataTable = self.context();
                                    coreApiClient.download(
                                        "chargingStations",
                                        `@/export`,
                                        dataTable.getFindAllOptions()
                                    );
                                },
                            },
                        },
                        insert: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
                            target: {
                                dialog: {
                                    attrs: {
                                        width: "600px",
                                    },
                                },
                            },
                            ext: {
                                condition() {
                                    return appService.activeTenantValid();
                                },
                            },
                        },
                    },
                    template: {
                        itemActionButtons: {
                            edit: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
                                target: {
                                    dialog: {
                                        attrs: {
                                            width: "600px",
                                        },
                                        ext: {
                                            subTitleMaker: "uniqueId",
                                        },
                                    },
                                },
                            },
                            delete: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {},
                            more: {
                                content: {
                                    icon: "mdi-dots-vertical",
                                },
                                target: {
                                    tooltip: {
                                        content: {
                                            text: "More Actions",
                                        },
                                    },
                                    menu: {
                                        content: {
                                            items: {
                                                viewChargingSessions: userManager.checkRole([
                                                    "systemAdmin",
                                                    "admin",
                                                    "cpoAdmin", "cpoMonitor",
                                                    "retailer",
                                                    "user",
                                                ]) && {
                                                    content: {
                                                        text: "View Charging Sessions",
                                                    },
                                                    on: {
                                                        xClick({ self }) {
                                                            const menu = self.context();
                                                            const { dataTable, item } = menu.context();
                                                            const { $router } = dataTable.context();
                                                            $router.push({
                                                                path: "/app/smart_socket_sessions",
                                                                query: {
                                                                    chargingStationId: item._id,
                                                                },
                                                            });
                                                        },
                                                    },
                                                },
                                                viewMqttAccount: userManager.checkRole([
                                                    "systemAdmin",
                                                    "admin",
                                                    "cpoAdmin",
                                                    "cpoMonitor",
                                                    "socketMonitor",
                                                    "retailer"
                                                ]) && {
                                                    content: {
                                                        text: "View MQTT Account",
                                                    },
                                                    target: {
                                                        dialog: {
                                                            attrs: {
                                                                width: "600px",
                                                            },
                                                            content: {
                                                                toolbar: {
                                                                    title: "MQTT Account",
                                                                    subTitle(dialog) {
                                                                        const menu = dialog.context();
                                                                        const btn = menu.context();
                                                                        const { item } = btn.context();
                                                                        return item.uniqueId;
                                                                    },
                                                                },
                                                                content: {
                                                                    type: "XForm",
                                                                    makeAttrs: (attrs, dialog) => {
                                                                        attrs.xContext = dialog;
                                                                        const { item } = dialog
                                                                            .context()
                                                                            .context()
                                                                            .context();
                                                                        attrs.xData = new DataContainer(item.mqttUser);
                                                                        attrs.xDisabled = new DataContainer(true);
                                                                        return attrs;
                                                                    },
                                                                    attrs: {
                                                                        xOptions: {
                                                                            content: {
                                                                                sections: {
                                                                                    default: {
                                                                                        fields: {
                                                                                            username: {
                                                                                                attrs: {
                                                                                                    label: "Username",
                                                                                                    required: true,
                                                                                                },
                                                                                            },
                                                                                            password: {
                                                                                                attrs: {
                                                                                                    label: "Password",
                                                                                                    required: true,
                                                                                                },
                                                                                            },
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    },
                                                                },
                                                            }
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            }
                        },
                    },
                    findAllOptionsFilter(options) {
                        const activeTenant = appService.getActiveTenant();
                        if (activeTenant) {
                            options.filters.push({
                                key: "tenantId",
                                operator: "equal_to",
                                value: activeTenant._id,
                            });
                        }

                        if (userManager.checkRole(["retailer"], true)) {
                            options.filters.push({
                                key: "retailerUserId",
                                operator: "equal_to",
                                value: userManager.getUserInfo()._id,
                            });
                        }

                        options.filters.push({
                            key: "deviceType",
                            operator: "equal_to",
                            value: 'smartsocket',
                        });

                        options.extraParams.currentTimeZoneOffset =
                            new Date().getTimezoneOffset() * -1 * 60 * 1000;
                        return options;
                    },
                },
                ext: {
                    dataProvider: {
                        async findAll(options) {
                            const payload = JSON.parse(options.payload || "{}");
                            const filters = payload.filters || [];
                            if (userManager.checkRole(["cpoAdmin", "cpoMonitor"], true)) {
                                const tenantId = userManager.getUserInfo().tenant._id;
                                filters.push({
                                    key: "tenantId",
                                    operator: "equal_to",
                                    value: tenantId,
                                });
                                options.payload = JSON.stringify({
                                    ...payload,
                                    filters,
                                });
                            }
                            const { items, count } = await coreApiClient.call(
                                "chargingStations",
                                "findAll",
                                options
                            );
                            return [items, count];
                        },
                        async insert(item) {
                            item.deviceType = 'smartsocket';
                            if (item.files?.length > 0) {
                                const imagesBase64 = await Promise.all(item.files.map(f => _this.createImage(f))).then(images => images.filter(i => !!i));
                                if (imagesBase64?.length > 0) {
                                    item.images = imagesBase64;
                                }
                            }
                            delete item.files;
                            return await coreApiClient.call(
                                "chargingStations",
                                "create",
                                undefined,
                                item
                            );
                        },
                        async update(item) {
                            delete item.images;
                            if (item.files?.length > 0) {
                                const imagesBase64 = await Promise.all(item.files.map(f => _this.createImage(f))).then(images => images.filter(i => !!i));
                                if (imagesBase64?.length > 0) {
                                    item.images = imagesBase64;
                                }
                            }
                            delete item.files;
                            return await coreApiClient.call(
                                "chargingStations",
                                "update",
                                {
                                    id: item._id,
                                },
                                {
                                    data: item,
                                }
                            );
                        },
                        async delete(item) {
                            return await coreApiClient.call("chargingStations", "delete", {
                                id: item._id,
                            });
                        },
                    },
                    default: {
                        defaultInputs: {
                            chargingLocationId: {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Site",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const tenant = userManager.getUserInfo().tenant;
                                                const filters = [
                                                    {
                                                        key: "_id",
                                                        operator: "equal_to",
                                                        value,
                                                    },
                                                ];
                                                if (tenant) {
                                                    filters.push({
                                                        key: "tenantId",
                                                        operator: "equal_to",
                                                        value: tenant._id,
                                                    });
                                                }
                                                const { items } = await coreApiClient.call(
                                                    "chargingLocations",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters,
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                            },
                            retailerId: {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Retailer",
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const filters = [
                                                    {
                                                        key: "_id",
                                                        operator: "equal_to",
                                                        value,
                                                    },
                                                ];
                                                const { items } = await coreApiClient.call(
                                                    "retailers",
                                                    "findAll",
                                                    {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters,
                                                        }),
                                                    }
                                                );
                                                return items;
                                            },
                                        },
                                    },
                                },
                            },
                            serialNumber: {
                                attrs: {
                                    label: "Serial Number",
                                    required: true,
                                },
                            },
                            uniqueId: {
                                attrs: {
                                    label: "Smart Socket ID",
                                    required: true,
                                },
                            },
                            isPrivate: {
                                type: "boolean",
                                attrs: {
                                    label: "Private",
                                },
                            },
                            chargerPointName: {
                                attrs: {
                                    label: "Smart Socket Name",
                                    required: true,
                                    default: "Charge Name"
                                },
                            },
                            power: {
                                type: "number",
                                attrs: {
                                    label: "Power (KW)",
                                },
                            },
                            files: {
                                type: "file",
                                attrs: {
                                    label: "Images",
                                    accept: "image/*",
                                    multiple: true
                                },
                            },
                            connectorSettingItems: {
                                type: "XArrayInput",
                                attrs: {
                                    label: "Receptacles Settings",
                                    required: true,
                                    xOptions: {
                                        content: {
                                            itemLabel: (_, index) => {
                                                return `Receptacle ${+index + 1}`;
                                            },
                                            itemProperties: {
                                                qrCode: {
                                                    attrs: {
                                                        label: "QR Code",
                                                        required: true,
                                                    },
                                                },
                                            },
                                            template: {
                                                formOptions: {
                                                    content: {
                                                        colLength: 12,
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                        insertForm: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
                            content: {
                                fieldNames: [
                                    "chargerPointName",
                                    "uniqueId",
                                    "serialNumber",
                                    "chargingLocationId",
                                    "retailerId",
                                    "power",
                                    "isPrivate",
                                    "files",
                                    "connectorSettingItems",
                                ],
                            },
                        },
                        editForm: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
                            content: {
                                fieldNames: [
                                    "chargerPointName",
                                    "serialNumber",
                                    "chargingLocationId",
                                    "retailerId",
                                    "power",
                                    "isPrivate",
                                    "files",
                                    "connectorSettingItems",
                                ],
                            },
                        },
                        delete: {
                            confirmDisplayField: "uniqueId",
                        },
                    },
                },
            },
        };
    },
    methods: {
        updateChargingStation(item) {
            const dataTable = this.tableContainer.value;
            const index = dataTable.items.value.findIndex(
                (it) => it.uniqueId === item.uniqueId
            );
            if (index >= 0) {
                const previousItem = dataTable.items.value[index];
                this.$set(
                    dataTable.items.value,
                    index,
                    merge.clone(previousItem, item)
                );
            }
        },
        createImage(file) {
            return new Promise((resolve, reject) => {
                if (file && typeof file !== "string") {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                } else {
                    resolve(null);
                }
            });
        },
    },
    created() {
        // Skip websocket subscription for cpoGroup role
        if (userManager.checkRole(["cpoGroup"], true)) {
            return;
        }

        const activeTenant = appService.getActiveTenant();

        const socketId = userManager.getUserInfo()._id;

        let channelName = "";

        if (activeTenant) {
            channelName = `private-chargingStations-tenantId=${activeTenant._id}`;
        } else if (userManager.checkRole(["cpoAdmin", "cpoMonitor", "socketMonitor"], true)) {
            channelName = `private-chargingStations-tenantId=${userManager.getUserInfo().tenant._id
                }`;
        } else if (userManager.checkRole(["retailer"], true)) {
            channelName = `private-chargingStations-tenantId=${userManager.getUserInfo().tenant._id
                }-retailerAdminUserId=${userManager.getUserInfo()._id}`;
        } else if (userManager.checkRole(["user"], true)) {
            channelName = `private-chargingStations-tenantId=${userManager.getUserInfo().tenant._id
                }-connectorItemsActiveUserId=${userManager.getUserInfo()._id}`;
        } else {
            channelName = `private-chargingStations`;
        }

        const centrifuge = centrifugeClientFactory(null, async () => {
            const {
                auth
            } = await coreApiClient.call("chargingStations", "subscribe", {
                channelName,
                socketId,
                id: "",
                connectorId: 0,
            });
            return auth;
        });
        this.centrifuge = centrifuge
        const self = this;


        if (channelName) {
            const sub = this.centrifuge.newSubscription(channelName)

            sub.on("publication", (ctx) => {
                const data = (ctx.data);
                self.updateChargingStation(data);
            });
            sub.subscribe();
            centrifuge.connect();
        }
    },
    destroyed() {
        if (this.centrifuge) {
            this.centrifuge.disconnect();
        }
    },
});
